<template>
  <div class="shortcut_div">
    <el-row>
      <el-col :span="6"><div class="sub-leftcontexttype bg-purple">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="sub-midcontexttype bg-purple-light">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="sub-rightcontexttype bg-purple">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="sub-rightcontexttype bg-purple-light">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
    </el-row>
    <el-row>
      <el-col :span="6"><div class="bottomsub-leftcontexttype bg-purple">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="bottomsub-midcontexttype bg-purple-light">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="bottomsub-rightcontexttype bg-purple">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
      <el-col :span="6"><div class="bottomsub-rightcontexttype bg-purple-light">
        <div class="type_img"></div>
        <div class="type_txt">分类1</div>
      </div></el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'ShortCut'
}
</script>
<style>
  .shortcut_div {
    height: 200px;
  }
  .el-row {
      margin-bottom: 20px; &:last-child {
     margin-bottom: 0;
   }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .grid-content {
    text-align:center;
    height: 100px;
    padding-top: 10px;
  }
  .bg-purple {
    background: transparent;
  }
  .bg-purple-light {
    background: transparent;
  }
  .el-row {
    margin-bottom: 0px;
  }
  .el-row {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .type_img {
    margin:0 auto;
    border-radius: 10px;
    border-color: #00bf8f;
    border:0.5px;
    border-style:solid;
    height: 64px;
    width: 64px;
    line-height:100px;
  }
  .type_txt {
    margin:0 auto;
  }
  .sub-leftcontexttype {
    border-color: #00bf8f;
    border-bottom: dotted 0.5px;
    border-left:dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
  .sub-midcontexttype {
    border-color: #00bf8f;
    border-bottom: dotted 0.5px;
    border-left:dotted 0.5px;
    border-right: dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
  .sub-rightcontexttype {
    border-color: #00bf8f;
    border-bottom: dotted 0.5px;
    border-right: dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
  .bottomsub-leftcontexttype {
    border-color: #00bf8f;
    border-left:dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
  .bottomsub-midcontexttype {
    border-color: #00bf8f;
    border-left:dotted 0.5px;
    border-right: dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
  .bottomsub-rightcontexttype {
    border-color: #00bf8f;
    border-right: dotted 0.5px;
    height: 100px;
    text-align: center;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/frontlayout/ShortCut.vue